module.exports = __webpack_public_path__ + "img/1.d57cf19c.png";